module.exports = __webpack_public_path__ + "static/media/trash.0e45d333.mp3";